import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../SessionChecker/SessionChecker";
import { useTranslation } from "react-i18next";

function PurchaseError({ theme, setCheckoutStatus }) {
  const [active, setActive] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
        setActive(true);
    }, 150);
  }, []);

  const { currentUserAddress, currentUserPhoneNumber } =
    useContext(AuthContext);

  const { t } = useTranslation();

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setCheckoutStatus();
          }, 150);
        }}
      ></div>
      <div className={`popupMainDiv noPadding ${theme} ${active && "active"}`}>
        <div className="popupContentDiv">
          {!currentUserAddress && (
            <>
              <div>
                {t(
                  "Your do not have an address, please register your address.",
                )}
              </div>

              <div
                className="linkDiv"
                onClick={() => {
                  setActive(false);
                  setTimeout(() => {
                    navigate("/edit_profile");
                  }, 150);
                }}
              >
                {t("Open profile edit")}
                <img src="/icons/link.png"></img>
              </div>
            </>
          )}

          {!currentUserPhoneNumber && (
            <>
              <div>
                {t(
                  "Your do not have an phone number, please register your phone number.",
                )}
              </div>

              <div
                className="linkDiv"
                onClick={() => {
                  setActive(false);
                  setTimeout(() => {
                    navigate("/edit_profile");
                  }, 150);
                }}
              >
                {t("Open profile edit")}
                <img src="/icons/link.png"></img>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default PurchaseError;
